import { belowBanner } from '@/shared/theme/bannerHeight'

const toastBackground = ($theme, kind) => {
  const backgrounds = {
    success: $theme.colors.noticeOkText,
    warning: $theme.colors.noticeWarnText,
    error: $theme.colors.noticeErrText,
  }

  return backgrounds[kind] || backgrounds.success
}

export const snackBarOverrides = (kind = 'success') => ({
  PlacementContainer: {
    style: () => ({
      top: belowBanner('0px'),
    }),
  },
  Root: {
    style: ({ $theme }) => ({
      backgroundColor: toastBackground($theme, kind),
      borderTopLeftRadius: '1rem',
      borderTopRightRadius: '1rem',
      borderBottomLeftRadius: '1rem',
      borderBottomRightRadius: '1rem',
      boxShadow: $theme.lighting.shadowPulseModal,
    }),
  },
  Content: {
    style: ({ $theme }) => ({
      paddingTop: '1rem',
      paddingBottom: '1rem',
      paddingLeft: '1rem',
      paddingRight: '1rem',
      color: $theme.colors.white,
    }),
  },
  StartEnhancerContainer: {
    style: () => ({
      paddingLeft: '0',
      marginRight: '0.5rem',
    }),
  },
  Message: {
    style: () => ({
      margin: '0',
      padding: '0',
      fontSize: '0.875rem',
      lineHeight: '1.4rem',
      fontWeight: 400,
    }),
  },
})
